import * as React from 'react'
import { API } from 'javascripts/api'
import ErrorMessages from 'javascripts/common/ErrorMessages'
import { TODO_LIST_REFRESH_EVENT } from 'spa/member/atoms/TodoList/todoListAtom'

interface JobApplicationCommentFormProps {
  handleSubmit: VoidFunction;
  jobOfferId: number;
}

interface JobApplicationCommentFormStates {
  errors: string[];
}

export default class JobApplicationCommentForm extends React.Component<JobApplicationCommentFormProps, JobApplicationCommentFormStates> {
  constructor(props: Readonly<JobApplicationCommentFormProps>) {
    super(props)

    this.state = {
      errors: [],
    }
  }

  componentDidMount() {
    const form = document.querySelector('form#job-offer-comment-form') as HTMLFormElement
    if (form) {
      form.addEventListener('submit', async (event) => {
        event.preventDefault()

        if (!confirm('応募しますか？')) {
          return
        }

        const formData = new FormData(form)
        const data = {
          job_offer_application: {
            job_offer_application_comment_attributes: {
              skills: formData.get('job_offer_application[job_offer_application_comment_attributes][skills]') as string || undefined,
              questions: formData.get('job_offer_application[job_offer_application_comment_attributes][questions]') as string || undefined,
              others: formData.get('job_offer_application[job_offer_application_comment_attributes][others]') as string || undefined,
            }
          }
        }

        try {
          await API.createJobOfferApplication(this.props.jobOfferId, data)
          this.setState({ errors: [] })
          // コメント付き応募も既に会員登録済みユーザーのみのフローのため、ヘッダーのやることリストを更新させる
          window.dispatchEvent(new Event(TODO_LIST_REFRESH_EVENT))
          this.props.handleSubmit()
        } catch (error: any) {
          const errorMessages = error.response?.data?.error || ['エラーが発生しました']
          this.setState({ errors: errorMessages })
        }
      })
    }
  }

  render() {
    return (
      <>
        <form id="job-offer-comment-form" className="job-offer-comment-form tech-form">
          <div className="job-offer-comment-form-inner">
            <div className="job-offer-comment-form-heading">
              応募フォーム
            </div>
            <ErrorMessages messages={this.state.errors} />
            <p>
              活かせる経験・スキル、質問などありましたら、該当のコメント欄に記入してください。すべて任意項目です。
            </p>
            <ul className="job-offer-comment-form-list">
              <li className="job-offer-comment-form-list-item">
                <a aria-controls="comment-skills" aria-expanded="true" className="job-offer-comment-form-list-item-heading" data-bs-toggle="collapse" href="#comment-skills" role="button">
                  この案件で活かせる経験・スキル
                </a>
                <div className="job-offer-comment-form-list-item-textarea-wrapper collapse show" id="comment-skills">
                  <p>
                    この項目を記入いただくと、企業への推薦がしやすくなります。
                  </p>
                  <textarea className="job-offer-comment-form-list-item-textarea" placeholder="例）直近5年間の〇〇開発経験を活かせます。" name="job_offer_application[job_offer_application_comment_attributes][skills]" id="job_offer_application_job_offer_application_comment_attributes_skills">
                  </textarea>
                </div>
              </li>
              <li className="job-offer-comment-form-list-item">
                <a aria-controls="comment-questions" aria-expanded="false" className="job-offer-comment-form-list-item-heading collapsed" data-bs-toggle="collapse" href="#comment-questions" role="button">
                  この案件に関する質問
                </a>
                <div className="job-offer-comment-form-list-item-textarea-wrapper collapse" id="comment-questions">
                  <textarea className="job-offer-comment-form-list-item-textarea" placeholder="例）どの工程を担当することになりますか？" name="job_offer_application[job_offer_application_comment_attributes][questions]" id="job_offer_application_job_offer_application_comment_attributes_questions">
                  </textarea>
                  <p>
                    この項目以外に質問を記入された場合は、回答しかねますのでご了承ください。
                    <br />
                    企業担当者への確認が必要な質問は、回答までに時間がかかる場合があります。
                  </p>
                </div>
              </li>
              <li className="job-offer-comment-form-list-item">
                <a aria-controls="comment-others" aria-expanded="false" className="job-offer-comment-form-list-item-heading collapsed" data-bs-toggle="collapse" href="#comment-others" role="button">
                  その他（上記2項目に当てはまらない場合）
                </a>
                <div className="job-offer-comment-form-list-item-textarea-wrapper collapse" id="comment-others">
                  <textarea className="job-offer-comment-form-list-item-textarea" name="job_offer_application[job_offer_application_comment_attributes][others]" id="job_offer_application_job_offer_application_comment_attributes_others">
                  </textarea>
                </div>
              </li>
            </ul>
            <div className="job-btn-container">
              <button name="button" type="submit" className="job-btn">
                応募する
              </button>
            </div>
          </div>
        </form >
      </>
    )
  }
}
